import { useEffect, useMemo, useState } from "react";
import {
  SakhadVerifyOtpInitData,
  SakhadVerifyOtpType,
} from "../../../types/sakhadAuth";
import { SubmitHandler, useForm } from "react-hook-form";
import {
  useSakhadSendOtp,
  useSakhadVerifyOtp,
} from "../../../hook/request/providerSakhad";
import { general } from "../../../store/action";
import {
  isHideModalDataSelector,
  isShowModalDataSelector,
  modalDataSelector,
  modalNameSelector,
} from "../../../store/selector/general";
import TextField from "../general/form/textField";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import Icon from "../general/icon";
import SakhadOtpTimer from "./SakhadOtpTimer";

type SakhadOtpModalProps = {
  modalData: any;
  modalName: string;
  isShowModalData: boolean;
  handleHideModal: any;
  handleResetModal: any;
};

type ModalInfoProps = {
  data?: any;
};

const SakhadOtpModal = ({
  modalData,
  modalName,
  isShowModalData,
  handleHideModal,
  handleResetModal,
}: SakhadOtpModalProps) => {
  const [showState, setShowState] = useState(false);
  const [modalInfo, setModalInfo] = useState<ModalInfoProps>({});
  const [sakhadOtpData, setSakhadOtpData] = useState<SakhadVerifyOtpType>(
    SakhadVerifyOtpInitData,
  );

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<SakhadVerifyOtpType>({
    defaultValues: useMemo(() => sakhadOtpData, [sakhadOtpData]),
  });

  const sakhadVerifyOtpRequest = useSakhadVerifyOtp();

  /// مدیریت نمایش مودال
  useEffect(() => {
    if (isShowModalData && modalName === "sakhadOtpModal") {
      setShowState(true);
      setModalInfo(modalData);
    }
  }, [isShowModalData, modalName, modalData]);

  /// مدیریت اینکه آیا درخواست موفقیت آمیز بوده یا نه
  /// اگر درخواست موفقیت امیز بوده مودال را ببند
  useEffect(() => {
    if (sakhadVerifyOtpRequest?.isSuccess) {
      handleSetShowModal();
    }
  }, [sakhadVerifyOtpRequest.isSuccess]);

  ////

  const handleSubmitCode: SubmitHandler<SakhadVerifyOtpType> = (data) => {
    sakhadVerifyOtpRequest.mutate({
      answer: data.answer,
    });
  };

  useEffect(() => {
    if (modalInfo.data?.requestId) {
      setSakhadOtpData((prevState) => ({
        ...prevState,
        requestId: modalInfo.data?.requestId,
      }));
    }
  }, [modalInfo?.data]);

  const handleSetShowModal = () => {
    if (sakhadVerifyOtpRequest?.isSuccess) {
      setShowState(false);
      handleHideModal();
    }
  };

  return (
    <Modal
      show={showState}
      onHide={handleSetShowModal}
      noCloseBtn={true} // It seems you have a custom close button
      centered
      bodyClassName="px-3 px-lg-5 pos-rel"
    >
      <div className="form-box w-1000 mw-100 mx-auto py-3">
        <div className="d-flex mb-4 fs-3 px-2">
          <div className=" px-2 flex-fill align-content-center">
            <h4 className="d-flex align-items-center title-dot font-16 font-weight-bold">
              ورود کد تأیید دریافتی از بیمه ساخد
            </h4>
          </div>
          <button
            type="button"
            className="btn-close-modal text-red-hover p-0 border-0 bg-transparent"
            onClick={handleSetShowModal}
            aria-label="بستن"
          >
            <Icon name="close-square" />
          </button>
        </div>
        <form onSubmit={handleSubmit(handleSubmitCode)}>
          <div className="col-12 px-4">
            <div className="form-group mb-3">
              <label className="inp-lbl me-2 mb-2" htmlFor="answer">
                لطفاً کد یکبار مصرف ارسال‌شده از طریق پیامک را وارد نمایید.
              </label>
              <TextField
                name="answer"
                placeholder="کد تایید را وارد کنید"
                control={control}
                // error={errors} // You had errors defined in useForm but not used. Add it back if needed.
              />
            </div>
          </div>

          {/* --- MODIFIED: Button container --- */}
          <div className={"px-4 d-flex align-items-center gap-3"}>
            <button
              className={"btn btn-primary rounded rounded-4"}
              type={"submit"}
              disabled={sakhadVerifyOtpRequest.isPending} // Disable while submitting
            >
              {sakhadVerifyOtpRequest.isPending ? "در حال ارسال..." : "ارسال"}
            </button>
            <SakhadOtpTimer />
          </div>
        </form>
      </div>
    </Modal>
  );
};
const mapStateToProps = (state: any) => ({
  modalData: modalDataSelector(state),
  modalName: modalNameSelector(state),
  isShowModalData: isShowModalDataSelector(state),
  isHideModalData: isHideModalDataSelector(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  handleHideModal: () => dispatch(general.handleHideModal()),
  handleResetModal: () => dispatch(general.handleResetModal()),
});
export default connect(mapStateToProps, mapDispatchToProps)(SakhadOtpModal);
